import React from 'react';

const Pause = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.5455 11.8184C23.2903 11.8184 22.2727 12.8359 22.2727 14.0911V25.9093C22.2727 27.1645 23.2903 28.182 24.5455 28.182C25.8006 28.182 26.8182 27.1645 26.8182 25.9093V14.0911C26.8182 12.8359 25.8006 11.8184 24.5455 11.8184ZM15.4544 11.8185C14.1992 11.8185 13.1816 12.8361 13.1816 14.0913V25.9094C13.1816 27.1646 14.1992 28.1822 15.4544 28.1822C16.7096 28.1822 17.7271 27.1646 17.7271 25.9094V14.0913C17.7271 12.8361 16.7096 11.8185 15.4544 11.8185Z"
      fill="white"
    />
  </svg>
);

export default React.memo(Pause);
